export var Thickness;
(function (Thickness) {
    Thickness["Tiny"] = "tiny";
    Thickness["Smallest"] = "smallest";
    Thickness["Smaller"] = "smaller";
    Thickness["Small"] = "small";
    Thickness["Normal"] = "normal";
    Thickness["Large"] = "large";
    Thickness["Larger"] = "larger";
    Thickness["Largest"] = "largest";
    Thickness["Huge"] = "huge";
})(Thickness || (Thickness = {}));
//# sourceMappingURL=ISeparator.js.map